import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../lib/utils';

const emptyVariants = cva('bg-muted p-8 rounded-xl space-y-4 text-b3', {
  variants: {
    variant: {
      default: 'text-muted-foreground',
    },
    width: {
      fit: 'w-fit ',
      full: 'w-full ',
    },
  },
  defaultVariants: {
    variant: 'default',
    width: 'full',
  },
});

export interface ComponentProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof emptyVariants> {
  title?: string | undefined;
  icon?: React.ReactNode | undefined;
}

function Empty({
  className,
  variant,
  width,
  icon,
  children,
  ...props
}: Readonly<ComponentProps>) {
  return (
    <div
      className={cn(emptyVariants({ variant, width }), className)}
      {...props}
    >
      {icon && <div>{icon}</div>}
      <div>{children}</div>
    </div>
  );
}

export { Empty, emptyVariants };
